import { callDeepLink, toQueryString } from '@croquiscom/web2app';

import {
  useCatalogProductIdParams,
  useGetPdpIntegratedData,
  useGoToReviewList,
  usePdpBaseInfo,
  usePdpConfig,
} from '@domains/pdp-common';

export function ReviewSummaryService() {
  const { isZigzagApp } = usePdpConfig();
  const { goToReviewList } = useGoToReviewList();
  const { catalog_product_id } = useCatalogProductIdParams();
  const { product, shop, flags } = usePdpBaseInfo({ catalog_product_id });
  const { related_product_review_summary, ux_review_list } = useGetPdpIntegratedData({
    catalog_product_id: product.id,
  });

  const reviewConfig = isZigzagApp
    ? {
        path: {
          review: {
            list: (review_id: string) => {
              const query = toQueryString({
                product_id: product.id,
                review_id,
                attachment_position: 0,
              });
              return `/photo_review?${query}`;
            },
          },
        },
        replaceReviewTab: () =>
          callDeepLink('/browser_product_review')({
            shop_main_domain: shop.main_domain,
            product_id: product.id,
          }),
      }
    : {
        path: { review: { list: (product_id: string) => `/review/list/${product_id}` } },
        replaceReviewTab: () => goToReviewList(),
      };
  const isHide = !flags?.show_review_summary_best_carousel;

  const adapted_review_summary = {
    all_count: related_product_review_summary?.overview.aggregate.internal.count ?? 0,
    ratings_average: related_product_review_summary?.overview.aggregate.internal.average_rating ?? 0,
    all_count_external_included: related_product_review_summary?.overview.aggregate.total.count ?? null,
    ratings_average_external_included: related_product_review_summary?.overview.aggregate.total.average_rating ?? null,
    attribute_list: [],
  };

  return {
    ...reviewConfig,
    isZigzagApp,
    catalog_product_id: product.id,
    related_product_review_summary: adapted_review_summary,
    ux_review_list,
    isHide,
  };
}
